import { i18n } from '@shared/i18n';

import { GenericModel } from '@shared/model/generic-model';

import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import DateModelField from '@shared/fields/date-model-field';
import BooleanField from '@shared/fields/boolean-field';
import EmailField from '@shared/fields/email-field';
import UrlField from '@shared/fields/url-field';
import PhoneField from '@shared/fields/phone-field';
import AddressField from '@shared/fields/address-field';
import ImagesField from '@shared/fields/images-field';
import JsonField from '@shared/fields/json-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

function label(name) {
  return i18n(`entities.stripeConnectedAccount.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  subpropertyName: new StringField('subpropertyName', label('subpropertyName')),
  phone: new PhoneField('phone', label('phone'), { required: true }),
  url: new UrlField('url', label('url'), { required: true }),
  country: new EnumeratorField('country', label('country'), getSharedEnumeratorField('country'), { required: true }),
  defaultCurrency: new EnumeratorField('defaultCurrency', label('defaultCurrency'), getSharedEnumeratorField('currency'), { required: true }),
  settings: new JsonField('settings', label('settings')),
  email: new EmailField('email', label('email'), { required: true }),
  address: new AddressField('address', label('address')),
  businessType: new EnumeratorField('businessType', label('businessType'), getSharedEnumeratorField('businessType'), { required: true }),
  productDescription: new StringField('productDescription', label('productDescription'), { required: true }),
  companyName: new StringField('companyName', label('companyName'), { required: true }),
  companyTaxId: new StringField('companyTaxId', label('companyTaxId'), { required: true }),
  mcc: new EnumeratorField('mcc', label('mcc'), getSharedEnumeratorField('mcc'), { required: true }),
  firstName: new StringField('firstName', label('firstName'), { required: true }),
  lastName: new StringField('lastName', label('lastName'), { required: true }),
  personalIdNumber: new StringField('personalIdNumber', label('personalIdNumber'), { required: true }),
  birthdate: new DateModelField('birthdate', label('birthdate'), {
    required: true,
    onlyPastDate: true
  }),
  verificationIdFront: new ImagesField('verificationIdFront', label('verificationIdFront'), null, { max: 1, required: true }),
  verificationIdBack: new ImagesField('verificationIdBack', label('verificationIdBack'), null, { max: 1, required: true }),
  tosAccepted: new BooleanField('tosAccepted', label('tosAccepted'), { mandatoryTrue: true }),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  createdRange: new DateTimeRangeField(
    'createdRange',
    label('createdRange'),
  ),
};

export class StripeConnectedAccountModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
